import { AxiosResponse } from "axios";
import {
  ApiResponse,
  QueryBundle,
  QueryParams,
  QueryPostEmail,
  QueryPostOfferView,
  QueryPostVoucherCode,
  QuerySaveEmail,
  TrackingLoggerParams,
  TrackingParams,
  TrackingShare,
} from "../../types/global.types";
import apiConfigTagApi, { apiConfigTrackingApi } from "../apiConfig";

export async function getTagCampaignOffersFromId(
  id: string,
  data: QueryParams
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTagApi
    .post<ApiResponse>(`/tag/campaigns/offers/${id}`, data)
    .catch((error) => {
      console.log(error);
    });
}

export async function postTagEmailOffer(
  data: QuerySaveEmail
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(`/tracking/emailoffer`, data)
    .catch((error) => {
      console.log(error);
    });
}

export async function postTrackingBundle(
  data: QueryBundle
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(`/tracking/bundle`, data)
    .catch((error) => {
      console.log(error);
    });
}

export async function getTrackingBundleById(
  id: string
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .get<ApiResponse>(`/tracking/bundle/${id}`)
    .catch((error) => {
      console.log(error);
    });
}

export async function postTrackingBundleById(
  id: string,
  userSessionId: string,
  email: string
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(`/tracking/bundle/${id}`, { userSessionId, email })
    .catch((error) => {
      console.log(error);
    });
}

export async function postOfferView(
  data: QueryPostOfferView
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(`/tracking/offerview`, data)
    .catch((error) => {
      console.log(error);
    });
}

export async function postTrackingShare(
  data: TrackingShare
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(`/tracking/share`, data)
    .catch((error) => {
      console.log(error);
    });
}

export async function postEmail(
  data: QueryPostEmail
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(`/tracking/emailonpost`, data)
    .catch((error) => {
      console.log(error);
    });
}

export async function getTrackingEvent(
  data: TrackingParams
): Promise<void | AxiosResponse<ApiResponse, any>> {
  const url = new URL(`${process.env.REACT_APP_TRACKAPI_URL}/tracking`);

  for (const [key, value] of Object.entries(data)) {
    value !== undefined && url.searchParams.set(key, value);
  }

  return await apiConfigTagApi
    .get<ApiResponse>(url.toString())
    .catch((error) => {
      console.log(error);
    });
}

export async function getCustomVoucher(
  data: QueryPostVoucherCode
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(
      `/tracking/voucher/custom`,
      data
    )
    .catch((error) => {
      console.log(error);
    });
}

export async function getBrandswapHostedDetails(
  id: string
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTagApi
    .get<ApiResponse>(`/tag/brshost/${id}`)
    .catch((error) => {
      console.log(error);
    });
}


export async function postTrackingLogger(
  data: TrackingLoggerParams
): Promise<void | AxiosResponse<ApiResponse, any>> {
  return await apiConfigTrackingApi
    .post<ApiResponse>(
      `/tracking/logger`,
      data
    )
    .catch((error) => {
      console.log(error);
    });
}